import {
  Filter,
  type SelectItem,
  useSelectQueryGate,
} from '@vrplatform/components';
import { useQuery } from '@vrplatform/data';
import { type Maybe, toTitleCase } from '@vrplatform/utils';
import type { BaseCustomFilterProps } from './_types';

interface Props extends BaseCustomFilterProps {
  categoryId: Maybe<string>;
  setCategoryId: (categoryId: string | null) => void;
}

export const CategoryFilter = ({
  categoryId,
  setCategoryId,
  label = 'Category',
}: Props) => {
  const gate = useSelectQueryGate({ value: categoryId });
  const queryData = useQuery(
    (q) => {
      return q
        .accountCategories({
          order_by: [
            {
              classification: 'asc_nulls_last',
            },
            {
              name: 'asc_nulls_last',
            },
          ],
        })
        .map<SelectItem>((category) => ({
          label: category.name,
          value: category.id,
          group: toTitleCase(category.classification),
        }));
    },
    {
      keepPreviousData: true,
      skip: !gate.shouldFetchAny,
    }
  );

  const options = queryData.data ?? [];

  const value = gate.hasValue
    ? (options.find((option) => option.value === categoryId) ?? null)
    : null;

  return (
    <Filter.Select
      type="single"
      label={label}
      value={value}
      data={{
        options,
        error: queryData.error,
        loading: queryData.isLoading,
      }}
      setValue={(next) => setCategoryId(next?.value || null)}
      popoverWidth={360}
      onOpenChange={gate.onOpenChange}
    />
  );
};
